module.exports = __webpack_public_path__ + "img/Syria.e2e206aa.svg";